// Source: https://stackoverflow.com/questions/28876300/deep-copying-array-of-nested-objects-in-javascript
// This allows you to deep copy an object, a nested object, and an array of objects and other items
export function deepCopy(obj) {
  let rv

  switch (typeof obj) {
    case 'object':
      if (obj === null) {
        // null => null
        rv = null
      } else {
        switch (Object.prototype.toString.call(obj)) {
          case '[object Array]':
            // It's an array, create a new array with
            // deep copies of the entries
            rv = obj.map(deepCopy)
            break
          case '[object Date]':
            // Clone the date
            rv = new Date(obj)
            break
          case '[object RegExp]':
            // Clone the RegExp
            rv = new RegExp(obj)
            break
          // ...probably a few others
          default:
            // Some other kind of object, deep-copy its
            // properties into a new object
            rv = Object.keys(obj).reduce((prev, key) => {
              // eslint-disable-next-line no-param-reassign
              prev[key] = deepCopy(obj[key])
              return prev
            }, {})
            break
        }
      }
      break
    default:
      // It's a primitive, copy via assignment
      rv = obj
      break
  }
  return rv
}

export function isArrayInArray(outerArray, innerArray) {
  return innerArray?.every((item) => outerArray.includes(item))
}

// generate a simple random id
// if you need cryptographically strong random strings use entropy-string
export const generateRandomId = () => Math.random().toString(16).slice(2)

/**
 * Check if an ID is in GUID/UUID format (8-4-4-4-12 hex digits)
 * @param {string|number} id - The ID to check
 * @returns {boolean} - True if the ID matches UUID format
 */
export const isGuidFormat = (id) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return uuidRegex.test(String(id))
}
